import { render, staticRenderFns } from "./BottomMatRevealSelector.vue?vue&type=template&id=86f6dfdc&scoped=true&"
import script from "./BottomMatRevealSelector.vue?vue&type=script&lang=ts&"
export * from "./BottomMatRevealSelector.vue?vue&type=script&lang=ts&"
import style0 from "./BottomMatRevealSelector.vue?vue&type=style&index=0&id=86f6dfdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f6dfdc",
  null
  
)

export default component.exports